import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'rol-worklist',
    templateUrl: './worklist.component.html',
    styleUrls: ['./worklist.component.scss'],
    standalone: false,
})
export class WorklistComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
